module.exports = __webpack_public_path__ + "gamecode/img/ztmslgkr_favicon.png?17ff2a3f";